export const URL_ACTIONS_KEYS = {
  loadStateFromURL: 'loadState',
  storeURL: 'store'
} as const;

export const URL_GETTERS_KEYS = {
  url: 'url'
} as const;

export const URL_MUTATIONS_KEYS = {
  setURL: 'setURL',
  setStateFromURL: 'setStateFromURL'
} as const;
